import React, { useMemo } from 'react';
import styles from './ManageContacts.module.scss';
import GroupIdentifierIcon from '@components/GroupIdentifierIcon';
import { ContactSearchModal } from '@components/Modals/ContactSearchModal';
import Group from '@models/Group';

export default function ManageContacts(props: {
  group: Group;
  open: boolean;
  onClose: () => void;
  onSelect: (contact: any) => void;
}) {
  const header = useMemo(
    () => (
      <span className={styles.list}>
        <span style={{ borderColor: props.group.color }} className={styles.listBorder} />
        <GroupIdentifierIcon group={props.group} className={styles.listIcon} />
        <span className="text-small">{props.group.title || 'New Group'}</span>
      </span>
    ),
    [],
  );

  return (
    <ContactSearchModal
      className={styles.modal}
      defaultContactSearchTerm="all"
      // If we keep this modal around, we should consider virtualizing the rendered results
      resultCount={50}
      closeModal={props.onClose}
      isOpen={props.open}
      contactIsSelected={({ id }) => props.group.hasContact(id)}
      onOptionSelected={props.onSelect}
      header={header}
    />
  );
}
